import React, { FC, useEffect } from 'react';
import { cleanUrlFromParameters } from '../../../utils/url-utils/urlUtils';
import { DecisionUploadFormContainer } from './form/DecisionUploadFormContainer';
import { DecisionUploadHeader } from './header/DecisionUploadHeader';
import { DecisionUploadRestriction } from './restriction/DecisionUploadRestriction';
import styles from './decision_upload.module.scss';

export const DecisionUpload: FC = () => {
  useEffect(() => {
    cleanUrlFromParameters();
  }, []);

  return (
    <div className={styles.container}>
      <DecisionUploadHeader />
      <DecisionUploadRestriction />
      <DecisionUploadFormContainer />
    </div>
  );
};
